import axios from "axios";
import { CHAT_ENDPOINT, CHAT_SECRET_KEY } from "@/components/constants";

export const getUserList = async (params: {
	userId: string;
	search?: string;
	role?: string;
}) => {
	const { data } = await axios.get(`${CHAT_ENDPOINT}/api/users`, {
		headers: {
			Authorization: `Bearer ${CHAT_SECRET_KEY}`,
		},
		params: {
			userId: params.userId,
			search: params.search,
			role: params.role,
		},
	});
	return data;
};

// Conversation
export const getConversation = async (params: {
	[key: string]: string | number | [] | undefined;
}) => {
	const { data } = await axios.get(`${CHAT_ENDPOINT}/api/conversations`, {
		headers: {
			Authorization: `Bearer ${CHAT_SECRET_KEY}`,
		},
		params,
	});
	return data;
};

export const createConversation = async (payload: {
	[key: string]: string | number | [] | undefined;
}) => {
	const { data } = await axios.post(
		`${CHAT_ENDPOINT}/api/messages/private`,
		{
			...payload,
		},
		{
			headers: {
				Authorization: `Bearer ${CHAT_SECRET_KEY}`,
			},
		},
	);
	return data;
};

export const createConversationGroup = async (payload: {
	[key: string]: string | number | string[] | undefined;
}) => {
	const { data } = await axios.post(
		`${CHAT_ENDPOINT}/api/conversations/group`,
		{
			...payload,
		},
		{
			headers: {
				Authorization: `Bearer ${CHAT_SECRET_KEY}`,
			},
		},
	);
	return data;
};

export const getConversationDetail = async (id: string) => {
	const { data } = await axios.get(`${CHAT_ENDPOINT}/api/conversations/${id}`, {
		headers: {
			Authorization: `Bearer ${CHAT_SECRET_KEY}`,
		},
	});
	return data;
};

// Messages
export const getMessage = async (
	conversationId: string,
	params: {
		[key: string]: string | number | [] | undefined;
	},
) => {
	const { data } = await axios.get(
		`${CHAT_ENDPOINT}/api/messages/${conversationId}`,
		{
			headers: {
				Authorization: `Bearer ${CHAT_SECRET_KEY}`,
			},
			params: {
				page: params.page,
				limit: params.limit,
			},
		},
	);
	return data;
};

export const sendMessage = async (payload: {
	[key: string]: string | number | [] | undefined;
}) => {
	const { data } = await axios.post(
		`${CHAT_ENDPOINT}/api/messages/private`,
		{
			...payload,
		},
		{
			headers: {
				Authorization: `Bearer ${CHAT_SECRET_KEY}`,
			},
		},
	);
	return data;
};

export const sendGroupMessage = async (payload: {
	[key: string]: string | number | [] | undefined;
}) => {
	const { data } = await axios.post(
		`${CHAT_ENDPOINT}/api/messages/group`,
		{
			...payload,
		},
		{
			headers: {
				Authorization: `Bearer ${CHAT_SECRET_KEY}`,
			},
		},
	);
	return data;
};

export const updateMessageRead = async (params: {
	[key: string]: string | number | [] | undefined;
}) => {
	const { data } = await axios.put(
		`${CHAT_ENDPOINT}/api/messageStatus/read`,
		{},
		{
			headers: {
				Authorization: `Bearer ${CHAT_SECRET_KEY}`,
			},
			params,
		},
	);
	return data;
};

// ເອກະສານ
export const getDocumentStatus = async (params: {
	[key: string]: string | number | [] | undefined;
}) => {
	const { data } = await axios.get(
		`${CHAT_ENDPOINT}/api/message-file-status/conversation`,
		{
			headers: {
				Authorization: `Bearer ${CHAT_SECRET_KEY}`,
			},
			params,
		},
	);
	return data;
};

export const getDocumentStatusRead = async (params: {
	[key: string]: string | number | [] | undefined;
}) => {
	const { data } = await axios.get(
		`${CHAT_ENDPOINT}/api/message-file-status/message`,
		{
			headers: {
				Authorization: `Bearer ${CHAT_SECRET_KEY}`,
			},
			params,
		},
	);
	return data;
};

export const acceptDocument = async (params: {
	[key: string]: string | number | [] | undefined;
}) => {
	const { data } = await axios.put(
		`${CHAT_ENDPOINT}/api/message-file-status`,
		{},
		{
			headers: {
				Authorization: `Bearer ${CHAT_SECRET_KEY}`,
			},
			params,
		},
	);
	return data;
};
